import PropTypes from "prop-types";
import {
  bannerDateFmt,
  formatRelativeDate,
} from "../../../../util/formatDate.js";
import s from "./EventsHeader.module.css";
import * as Icons from "./Icons.jsx";
import { Badge, Typography } from "../../../../themeV2";

const LiveBadge = () => (
  <span className={s.liveBadge}>
    <span className={s.liveDot} />
    Live
  </span>
);

const OffCameraBadge = () => <span className={s.offBadge}>Fulfillment</span>;

export default function EventsHeader({
  nextEvent,
  nextIsLive,
  nextDate,
  countdown,
  totalCount,
  expanded,
  bodyId,
  onToggle,
}) {
  const nextRelative = formatRelativeDate(nextDate);
  const nextDateStr = nextDate ? bannerDateFmt.format(nextDate) : "";

  return (
    <button
      type="button"
      className={s.header}
      onClick={onToggle}
      aria-expanded={expanded}
      aria-controls={bodyId}
    >
      <Icons.CalendarIcon className={s.headerIcon} />

      <div className={s.headerText}>
        <Typography variant="label-lg" color="variant" weight="bold" as="span">
          Upcoming Events
        </Typography>
        <div className={s.headerNext}>
          {nextIsLive ? <LiveBadge /> : <OffCameraBadge />}
          <span className={s.nextTitle}>
            {nextEvent.event_title || "Signing session"}
          </span>
          <span className={s.nextDate}>· {nextDateStr}</span>
          {nextRelative && (
            <span className={s.nextRelative}>{nextRelative}</span>
          )}
        </div>
      </div>

      {nextIsLive && countdown && (
        <span className={s.countdown}>{countdown}</span>
      )}
      {totalCount > 1 && (
        <Badge
          variant="count"
          tone="neutral"
          count={totalCount}
          className={s.count}
          aria-hidden="true"
        />
      )}
      <span className={s.toggle}>
        <Icons.ArrowIcon />
      </span>
    </button>
  );
}

EventsHeader.propTypes = {
  nextEvent: PropTypes.object.isRequired,
  nextIsLive: PropTypes.bool.isRequired,
  nextDate: PropTypes.instanceOf(Date),
  countdown: PropTypes.string,
  totalCount: PropTypes.number.isRequired,
  expanded: PropTypes.bool.isRequired,
  bodyId: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
};
